import { render } from "./Tables.vue?vue&type=template&id=2a0f89bd&scoped=true"
import script from "./Tables.vue?vue&type=script&lang=js"
export * from "./Tables.vue?vue&type=script&lang=js"

import "./Tables.vue?vue&type=style&index=0&id=2a0f89bd&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/BLEIN/mi-stock-blein-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0f89bd"]])

export default __exports__